const TIERS = {
    IMMEDIATE: { bg: "bg-red-500/10", fg: "text-red-400", bd: "border-red-500/30", label: "Immediate" },
    PRIORITY: { bg: "bg-amber-400/10", fg: "text-amber-300", bd: "border-amber-400/30", label: "Priority" },
    STANDARD: { bg: "bg-blue-500/10", fg: "text-blue-400", bd: "border-blue-500/30", label: "Standard" },
};

export default function PriorityBadge({ value }) {
    const s = TIERS[value] || TIERS.STANDARD;
    return (
        <span
            data-testid={`priority-badge-${value}`}
            className={`inline-flex items-center px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider rounded-sm border ${s.bg} ${s.fg} ${s.bd}`}
        >
            {s.label}
        </span>
    );
}
